module.exports = __webpack_public_path__ + "images/apple-touch-icon-120x120.41030a60798997b6df13c2c967b7d2be.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/favicons/apple-touch-icon-120x120.png
// module id = 989
// module chunks = 0